import { translationUtils, typeUtils } from '@festina-life/core'
import cx from 'classnames'
import { useState } from 'react'

import { Button } from '../../actions/button/Button'
import { useTranslate } from '../../hooks/useTranslate'
import { Icon } from '../../structure/icon/Icon'
import { typographyStyles } from '../../structure/typography/styles'

export type Props = {
  data: unknown
  isInitiallyClosed?: boolean
  name?: string | null
  isLast?: boolean
  className?: string
}

export const JsTreeView = ({
  data,
  isInitiallyClosed = false,
  name = null,
  isLast = true,
  className = '',
}: Props) => {
  const translate = useTranslate()

  const [isOpen, setIsOpen] = useState(!isInitiallyClosed)
  const isDataArray = Array.isArray(data)

  const endStuff = (
    <>
      {isDataArray ? ']' : '}'}
      {!isLast ? ',' : ''}
    </>
  )

  return (
    <div
      className={cx(
        'flex-col items-start',
        typographyStyles({ size: 'sm' }),
        className,
      )}
    >
      <Button
        variant="text"
        onClick={() => setIsOpen(!isOpen)}
        className="text-inherit! flex!"
      >
        <Icon name={isOpen ? 'ChevronDown' : 'ChevronRight'} color="unset" />
        {name && <strong>{name}:&nbsp;</strong>}
        {isDataArray ? '[' : '{'}
        {!isOpen && (
          <>
            {typeUtils.isObject(data) && typeUtils.isReactNode(data['name'])
              ? data['name']
              : '...'}
            {endStuff}
          </>
        )}
      </Button>
      {isOpen &&
        typeof data === 'object' &&
        data !== null &&
        Object.entries(data)
          .sort(([key1], [key2]) => key1.localeCompare(key2))
          // oxlint-disable-next-line max-params
          .map(([key, value], index, thisArray) =>
            typeof value === 'object' ? (
              <JsTreeView
                // oxlint-disable-next-line react/no-array-index-key -- @BETA this looks odd though, e.g. v could be anything but added as if it was a string
                key={`${name}-${value}-${index}`}
                data={value}
                isLast={index === thisArray.length - 1}
                name={isDataArray ? null : key}
                className="ms-3"
              />
            ) : (
              <p
                // oxlint-disable-next-line react/no-array-index-key -- @BETA this looks odd though, e.g. v could be anything but added as if it was a string
                key={`${name}-${value}-${index}`}
                className="ms-3 block"
              >
                {isDataArray ? '' : <strong>{key}: </strong>}
                {typeof value === 'boolean'
                  ? translationUtils.translateBoolean(value, translate)
                  : typeUtils.isReactNode(value) && value}
                {index === thisArray.length - 1 ? '' : ','}
              </p>
            ),
          )}
      {isOpen && endStuff}
    </div>
  )
}
